module.exports = __webpack_public_path__ + "img/ringPerimeter.e0936be.webp";